module.exports = __webpack_public_path__ + "static/media/circle-check.c976de57.svg";